import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

export const Text: React.FC<React.PropsWithChildren<TypographyProps>> = (props) => {
  const { children, ...rest } = props;

  return <Typography {...rest}>{children ?? ''}</Typography>;
};
